<script lang="ts">
  import { onMount } from "svelte";
  import UserGrid from "../components/content/user/UserGrid.svelte";
  import UserDrawer from "../components/drawers/UserDrawer.svelte";
  import ObjectDrawerSystem from "../components/drawers/ObjectDrawerSystem.svelte";

  onMount(async () => {});
</script>

<div class="component-container">
  <div class="component-content app-grid inside-object">
    <UserGrid />
    <UserDrawer />
    <ObjectDrawerSystem />
  </div>
</div>
